import React from 'react'
import { Box, useTheme, Typography, Grid, alpha } from '@mui/material'
import { GridFooterContainer } from '@mui/x-data-grid-pro'
const _tooltipGridFooter = title => {
  return <Typography>{title}</Typography>
}
export const ApprovalsGridFooter = ({
  massUpdateData,
  selectionModel = [],
  rowCount,
  onChange,
  onUpdate,
  approvals = [],
  anchorEl,
  handleDeleteClick,
  handleConfirmDelete,
  handleClosePopover,
  handleEditClick,
  handleClone,
  selectedData,
  selectedDiscoveryForm,
}) => {
  const theme = useTheme()
  const open = Boolean(anchorEl)
  const id = open ? 'grid-footer-popover' : undefined

  return (
    <GridFooterContainer>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}></Box>
      <>
        <Grid
          container
          sx={{
            padding: 1,
            alignItems: 'center',
            minHeight: 50,
            backgroundColor: theme.palette.background.default,
            gap: 1,
          }}
          justifyContent='flex-start'
        >
          <Grid item>
            <Typography variant='body2' mr={2}>
              Total Rows:
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: alpha(theme.palette.text.complete, 0.8) }}>
              {rowCount}
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: alpha(theme.palette.text.primary, 0.6) }}>
              /
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ color: alpha(theme.palette.text.primary, 0.6) }}>
              {approvals.length}
            </Typography>
          </Grid>
        </Grid>
      </>
    </GridFooterContainer>
  )
}
